import styled from 'styled-components';

interface ButtonProps {
    readonly yellow?: boolean;
    readonly green?: boolean;
}

export const GreenButton = styled.button`
    background: linear-gradient(0deg, #629361, #629361), #009688;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
    border-radius: 10px;
    height: 36px;
    width: 88px;
    color: white;
    font-size: 12px;
    align-self: flex-end;
    cursor: pointer;

    :hover {
        filter: brightness(120%);
    }

`;

export const RedButton = styled.button<ButtonProps>`
    background: ${props => props.disabled ? "#afafaf" : (props["yellow"] ?
        "linear-gradient(0deg, #FFA620, #FFA620), #009688" :
        props["green"] ?
            "linear-gradient(0deg, #4B975C, #4B975C), #009688" :
            "linear-gradient(0deg, #BD3636, #BD3636), #009688")};
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
    border-radius: 10px;
    height: 36px;
    width: 88px;
    color: white;
    font-size: 12px;
    align-self: flex-end;
    cursor: pointer;

    :hover {
        filter: ${props => !props.disabled && "brightness(120%)"};
    }

`;

export const WhiteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    height: 36px;
    font-size: 12px;
    align-self: flex-end;

    :hover {
        cursor: pointer;
    }

    color: #629361;

    background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #009688;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);


    :hover {
        filter: brightness(120%);
    }

`;

